<template>
  <div class="dt-dialog-container">
    <template v-if="containerFlag">
      <v-dialog :value="dialogFlag" persistent :width="dialogWidth">
        <slot></slot>
      </v-dialog>
    </template>
  </div>
</template>

<script>
// Must be placed as the direct child of the host component - Or else the Parent returns undefined

export default {
  props: {
    modalKey: {
      required: true,
    },
    width: {
      default: "medium",
    },
  },
  // mounted: function () {
  //   console.log(this.$parent, { [`${this.modalKey}ModalContainer`]: this.$parent[`${this.modalKey}ModalContainer`] });
  // },
  computed: {
    containerFlag: function () {
      return this.$parent[`${this.modalKey}ModalContainer`];
    },
    dialogFlag: function () {
      return this.$parent[`${this.modalKey}Modal`];
    },
    dialogWidth: function () {
      switch (this.width) {
        case "small": {
          return 390;
        }
        case "small2": {
          return 480;
        }
        case "small3": {
          return 562;
        }
        case "medium": {
          return 762;
        }
        case "medium2": {
          return 800;
        }
        case "medium3": {
          return 900;
        }
        case "medium4": {
          return 1000;
        }
        case "wide": {
          return 1200;
        }
        default: {
          return `${this.width}px`;
        }
      }
    },
  },
};
</script>

<style lang="scss">
</style>